const caption = {
    s: 1.4,
    m: 1.4,
    l: 1.3,
} as const;

const subtitle = {
    s: 1.4,
    m: 1.3,
    l: 1.2,
} as const;

export const heights = {
    'body-text': caption,
    caption,
    subtitle,
};
